// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { SiteV3ClientGeneratedAddressUpsearchModel } from './siteV3ClientGeneratedAddressUpsearchModel.js';
import type { SiteV3ClientGeneratedContactUpsearchModel } from './siteV3ClientGeneratedContactUpsearchModel.js';
import type { SiteV3ClientGeneratedEmailAddressUpsearchModel } from './siteV3ClientGeneratedEmailAddressUpsearchModel.js';
import type { SiteV3ClientGeneratedExternalIdUpsearchModel } from './siteV3ClientGeneratedExternalIdUpsearchModel.js';
import type { SiteV3ClientGeneratedGlobalIdUpsearchModel } from './siteV3ClientGeneratedGlobalIdUpsearchModel.js';
import type { SiteV3ClientGeneratedPhoneUpsearchModel } from './siteV3ClientGeneratedPhoneUpsearchModel.js';
import type { SiteV3ClientGeneratedRoleType } from './siteV3ClientGeneratedRoleType.js';
import type { SiteV3ClientGeneratedSiteLicenseUpsearchModel } from './siteV3ClientGeneratedSiteLicenseUpsearchModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SiteV3ClientGeneratedSiteUpsearchModel {
    'siteId'?: number | null;
    'siteLicenses': Array<SiteV3ClientGeneratedSiteLicenseUpsearchModel>;
    'addresses': Array<SiteV3ClientGeneratedAddressUpsearchModel>;
    'contacts': Array<SiteV3ClientGeneratedContactUpsearchModel>;
    'emailAddresses': Array<SiteV3ClientGeneratedEmailAddressUpsearchModel>;
    'externalIds': Array<SiteV3ClientGeneratedExternalIdUpsearchModel>;
    'phoneNumbers': Array<SiteV3ClientGeneratedPhoneUpsearchModel>;
    'globalIds': Array<SiteV3ClientGeneratedGlobalIdUpsearchModel>;
    'siteRoleType'?: SiteV3ClientGeneratedRoleType;
    'description': string;
    'nickName': string;
    'businessStartTime'?: Moment | null;
    'businessEndTime'?: Moment | null;
    'siteNote': string;
    'npi': string;
    'stateTaxId': string;
    'billingCode': string;
    'isSitePayable'?: boolean | null;
    'isActive'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SiteV3ClientGeneratedSiteUpsearchModel>> = [
        {
            "name":     "siteId",
            "baseName": "siteId",
            "type":     "number"
        },
        {
            "name":     "siteLicenses",
            "baseName": "siteLicenses",
            "type":     "Array<SiteV3ClientGeneratedSiteLicenseUpsearchModel>"
        },
        {
            "name":     "addresses",
            "baseName": "addresses",
            "type":     "Array<SiteV3ClientGeneratedAddressUpsearchModel>"
        },
        {
            "name":     "contacts",
            "baseName": "contacts",
            "type":     "Array<SiteV3ClientGeneratedContactUpsearchModel>"
        },
        {
            "name":     "emailAddresses",
            "baseName": "emailAddresses",
            "type":     "Array<SiteV3ClientGeneratedEmailAddressUpsearchModel>"
        },
        {
            "name":     "externalIds",
            "baseName": "externalIds",
            "type":     "Array<SiteV3ClientGeneratedExternalIdUpsearchModel>"
        },
        {
            "name":     "phoneNumbers",
            "baseName": "phoneNumbers",
            "type":     "Array<SiteV3ClientGeneratedPhoneUpsearchModel>"
        },
        {
            "name":     "globalIds",
            "baseName": "globalIds",
            "type":     "Array<SiteV3ClientGeneratedGlobalIdUpsearchModel>"
        },
        {
            "name":     "siteRoleType",
            "baseName": "siteRoleType",
            "type":     "SiteV3ClientGeneratedRoleType"
        },
        {
            "name":     "description",
            "baseName": "description",
            "type":     "string"
        },
        {
            "name":     "nickName",
            "baseName": "nickName",
            "type":     "string"
        },
        {
            "name":     "businessStartTime",
            "baseName": "businessStartTime",
            "type":     "Date"
        },
        {
            "name":     "businessEndTime",
            "baseName": "businessEndTime",
            "type":     "Date"
        },
        {
            "name":     "siteNote",
            "baseName": "siteNote",
            "type":     "string"
        },
        {
            "name":     "npi",
            "baseName": "npi",
            "type":     "string"
        },
        {
            "name":     "stateTaxId",
            "baseName": "stateTaxId",
            "type":     "string"
        },
        {
            "name":     "billingCode",
            "baseName": "billingCode",
            "type":     "string"
        },
        {
            "name":     "isSitePayable",
            "baseName": "isSitePayable",
            "type":     "boolean"
        },
        {
            "name":     "isActive",
            "baseName": "isActive",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return SiteV3ClientGeneratedSiteUpsearchModel.attributeTypeMap;
    }
}
